<template>
  <v-dialog v-model="showDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{
          user.id ? 'Editar usuário' : 'Novo usuário'
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex sm12 v-if="profile == 'tcs'">
              <v-autocomplete
                label="Cliente"
                v-model="user.client_id"
                :items="clients"
                item-text="name"
                item-value="id"
                required
              ></v-autocomplete>
              <small class="validFields" v-if="!user.client_id"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm6>
              <v-text-field label="Nome" v-model="user.name" required>
              </v-text-field>
              <small class="validFields" v-if="!user.name"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="E-mail"
                v-model="user.email"
                required
              ></v-text-field>
              <small class="validFields" v-if="!user.email"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm6>
              <v-select
                label="Gênero"
                v-model="user.gender"
                :items="genders"
                required
              ></v-select>
              <small class="validFields" v-if="!user.gender"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="Complemento"
                v-model="user.complement"
              ></v-text-field>
            </v-flex>

            <v-flex sm8 v-if="!user.id">
              <v-text-field
                label="Senha Provisória"
                v-model="user.password"
                required
              ></v-text-field>
              <small class="validFields" v-if="!user.password"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm4 v-if="!user.id">
              <v-switch
                v-model="user.hasForPasswordChange"
                :label="`Solicitar nova senha no login`"
              ></v-switch>
            </v-flex>

            <v-flex sm6>
              <v-text-field
                v-mask="'###.###.###-##'"
                label="CPF"
                v-model="user.cpf"
                required
              ></v-text-field>
              <small class="validFields" v-if="!user.cpf"
                >*Campo obrigatório</small
              >
            </v-flex>
            <v-flex sm6>
              <v-text-field
                v-mask="'###########'"
                label="CNH"
                v-model="user.drive_license"
                required
              ></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                v-mask="'(##)#####-####'"
                label="Celular"
                v-model="user.phone"
                required
              ></v-text-field>
              <small class="validFields" v-if="!user.phone"
                >*Campo obrigatório</small
              >
            </v-flex>

            <v-flex sm12>
              <v-row>
                <v-col cols="12" sm="4" md="4"
                  ><v-switch v-model="user.status" label="STATUS"></v-switch
                ></v-col>
                <v-col cols="12" sm="4" md="4"
                  ><v-switch v-model="user.approved" label="APROVADO"></v-switch
                ></v-col>
              </v-row>
            </v-flex>

            <v-flex sm12>
              <label>Perfil</label>
              <div class="radios">
                <input
                  required
                  name="profile"
                  id="tcs"
                  v-model="user.profile_id"
                  type="radio"
                  v-bind:value="profiles.get('tcs')"
                />
                <label for="tcs">TCS</label>
                <input
                  required
                  name="profile"
                  id="adm"
                  v-model="user.profile_id"
                  type="radio"
                  v-bind:value="profiles.get('adm')"
                />
                <label for="adm">Administrador</label>

                <input
                  required
                  type="radio"
                  id="user"
                  v-model="user.profile_id"
                  name="profile"
                  v-bind:value="profiles.get('user')"
                />
                <label for="user">Usuário</label>

                <input
                  v-if="profile == 'tcs'"
                  required
                  type="radio"
                  id="support"
                  v-model="user.profile_id"
                  name="profile"
                  v-bind:value="profiles.get('support')"
                />
                <label v-if="profile == 'tcs'" for="support">Suporte</label>
              </div>
              <small class="validFields" v-if="!user.profile_id"
                >*Campo obrigatório</small
              >
            </v-flex>

            <v-flex sm12>
              <label>Black List</label>
              <div class="radios">
                <input
                  required
                  v-model="user.black_list"
                  type="checkbox"
                  :value="user.black_list"
                />
                <label for="blacklist">Adicionar a black list</label>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$emit('cancel')"
          >Cancelar</v-btn
        >
        <v-btn
          color="blue darken-1"
          :disabled="
            !user.name ||
              !user.cpf ||
              !user.phone ||
              !user.gender ||
              !user.client_id ||
              !user.email ||
              !user.profile_id
          "
          text
          @click="$emit('salvar')"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import UserController from '../../controllers/UserController.js';
import ClientController from '../../controllers/ClientController.js';

export default {
  data() {
    return {
      userController: new UserController(this.$resource),
      clientController: new ClientController(this.$resource),
      profile: localStorage.getItem('profile'),
      profiles: new Map(),
      clients: [],
      genders: ['Masculino', 'Feminino', 'Outro', 'Prefiro não dizer'],
    };
  },
  props: {
    showDialog: Boolean,
    user: Object,
  },
  created() {
    this.getProfiles();
    this.getClients();
  },
  methods: {
    async getProfiles() {
      let result = await this.userController.getProfile();

      result.forEach(element => {
        this.profiles.set(element.description, element.id);
      });
    },
    getClients() {
      this.clientController.getAllClients().then(clients => {
        this.clients = clients;
      });
    },
  },
  watch: {
    user(value) {
      if (this.showDialog) {
        this.user.client_id = value.clientUser[0].client_id;
        this.user.profile_id = value.clientUser[0].profile_id;
        this.user.complement = value.user_address
          ? value.user_address.complement
          : null;
      }
    },
  },
};
</script>
<style scoped>
.validFields {
  font-size: 10px;
  color: rgb(196, 12, 12);
}
</style>
